'use strict';

var propTypes = require('./prop-types.js');
var isNumber = require('./is-number.js');
var requiredParameter = require('./required-parameter.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./is-defined-and-not-null.js');
require('./is-defined.js');
require('./is-null.js');
require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Rounds a float number with the passed decimals.
 *
 * @function
 * @param {number} value - A number value.
 * @param {number} decimals - Number of decimals to round.
 * @returns {number} Returns the number rounded with the passed decimals.
 * @example
 * floatRound(1.005, 2);
 * // => 1.01
 */

var floatRound = function floatRound() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requiredParameter('value');
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (isNumber(value) && isNumber(decimals)) {
    return Number("".concat(Math.round("".concat(value, "e").concat(decimals)), "e-").concat(decimals));
  }

  throw new TypeError('Invalid parameter type: Number expected.');
};

floatRound.HELPER_ID = 'Gearz.JsUtils.floatRound';
floatRound.returnType = propTypes.numberWithDescription('Returns the number rounded with the passed decimals.');
floatRound.parameterTypes = {
  value: propTypes.numberWithDescription('A number value.').isRequired,
  decimals: propTypes.numberWithDescription('Number of decimals to round.')
};
floatRound.defaultParameters = {
  decimals: 2
};

module.exports = floatRound;
